import { nodeViewDecorators } from './../../../../ricos-common-plugins/viewer';
import type { NodeViewDecorator } from './../../../../ricos-types';

import { BreakoutDecorator } from './breakoutDecorator';
import { Decorators as NodeViewDecorators } from './nodeViewDecorators';

export const decorators: NodeViewDecorator<JSX.Element>[] = [
  ...nodeViewDecorators,
  BreakoutDecorator,
];

export default NodeViewDecorators;
